import { BaseActions, ActionMenuItem } from "../../components/action-menu/ActionMenuItem";
import i18n from "../../services/localization-service/i18n";
import { AlarmSchemeListActionEnum } from "../../components/alarm-scheme-list/AlarmSchemeListUtils";
import { AddIcon } from "../../components/action-menu/ActionMenuIcons";

export type AlarmSchemeListAdminActions = AlarmSchemeListActionEnum.Add;

export type AlarmSchemeListActionItem = {
    action: AlarmSchemeListActionEnum | BaseActions | string
} & ActionMenuItem;

export const actionItems: AlarmSchemeListActionItem[] = [{
    label: i18n.t("buttons.addAlarmScheme"),
    icon: AddIcon,
    action: AlarmSchemeListActionEnum.Add,
    order: 0
}];




